import { DomainBase } from "./DomainBase";

export class PromoProductsClass extends DomainBase{
    constructor() {
        super();
        this.promotion = null;
        this.branch = null;
      //  this.section = null;
        this.promoProductsDetail = [];
    }
}

// The product list (GetAllByBranch) is a flat view: `unit`, `category` etc.
// are names/ids, not objects, so sending the whole row failed model binding
// ("could not be converted to ...Models.Unit"). Send only the identity.
export const toPromoProductRef = (product) => {
    if (!product) return null;
    const ref = new DomainBase();
    ref.id = product.id ?? 0;
    ref.guid = product.guid ?? "";
    ref.name = product.name ?? "";
    return ref;
};